module.exports = __webpack_public_path__ + "img/icn_hot_disable.d2f18bae.svg";